module.exports = __webpack_public_path__ + "assets/img/79eb5a13c05766aee4d179adc1b4105c.png";